import { MatchSummaries } from './../types'
import { Market } from 'smartstream-widgets/types/market'

export function buildMatchState(matchSummaries: MatchSummaries | null) {
  const { awayScore, homeScore, matchStatus, phase } = matchSummaries || {}
  return {
    scoreAway: awayScore || 0,
    scoreHome: homeScore || 0,
    matchStatus: matchStatus || '',
    phase: phase || ''
  }
}

export function getMarketsLabels(
  markets: {
    [K in string]: Array<Market>
  },
  initialMarketType: string,
  translations: {
    [K in string]: string
  }
): Array<{ id: number, marketKey: string, name: string }> {
    const keys: Array<string> = markets && Object.keys(markets)

    const initialMarketTypeIndex = keys.findIndex(key => key === initialMarketType)
    if (initialMarketTypeIndex > 0) {
      keys.splice(initialMarketTypeIndex, 1)
      keys.unshift(initialMarketType)
    }

    return keys
      .filter(key => markets[key] && markets[key].length > 0)
      .map((key, index) => {
        return {
          id: index,
          marketKey: key,
          name: translations[key]
        }
      })
}
